'use client'

import { Button } from '@/core/components/form/button/button'
import { ItemArt } from '@/features/veluvit/components/ui/item-art'
import { CloseX } from '@/features/veluvit/components/overlay/layer-parts'
import { GemIcon } from '@/features/veluvit/components/ui/currency-icon'
import { fmt } from '@/features/veluvit/lib/format'
import { openCharge } from '@/features/veluvit/services/wallet.actions'
import { useSessionStore } from '@/features/veluvit/stores/session.store'

export default function PaywallSheet({ need }: { need: number }) {
  const gem = useSessionStore((state) => state.data?.wallet.balance ?? 0)
  const rows: [string, number, boolean][] = [
    ['필요', need, false],
    ['보유', gem, false],
    ['부족', Math.max(0, need - gem), true],
  ]
  return (
    <>
      <div className="-mt-1.5 flex justify-end">
        <CloseX className="opacity-60" />
      </div>
      <div className="pt-1 text-center">
        <ItemArt
          name="gem"
          px={128}
          className="mx-auto size-16 drop-shadow-[0_10px_24px_color-mix(in_srgb,var(--point)_45%,transparent)]"
        />
        <h3 className="mt-1 text-c20 font-extrabold">젬이 부족해요</h3>
      </div>
      <div className="mt-3.5 rounded-field bg-foreground/[0.05] px-3.5 py-2">
        {rows.map(([label, value, short]) => (
          <div
            key={label}
            className="flex justify-between py-1.5 text-c14 text-t2"
          >
            <span>{label}</span>
            <b
              className={
                short
                  ? 'flex items-center gap-1 text-coral tabular-nums'
                  : 'flex items-center gap-1 text-t1 tabular-nums'
              }
            >
              <GemIcon />
              {fmt(value)}
            </b>
          </div>
        ))}
      </div>
      <Button className="mt-5 w-full" size="lg" onClick={openCharge}>
        충전소로 이동
      </Button>
    </>
  )
}
